import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import * as Type from "./type";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import { putSaga } from "src/request/put";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { deleteSaga } from "src/request/delete";
//***DISCOUNT PLANS***//
export const getDiscountPlans = createAction(
  "GET_DISCOUNT_PLANS",
  ({ payload, params }: SagaActionParams<Type.DiscountPlanDto[]>) => ({
    payload,
    url: "/api/admin/discountplan" + (params ? params : ""),
  })
);
export const getDiscountPlanDetails = createAction(
  "GET_DISCOUNT_PLAN_DETAILS",
  ({ payload, id }: SagaActionParams<Type.DiscountPlanDetailDto>) => ({
    payload,
    url: "/api/admin/discountplan/" + id,
  })
);
export const createDiscountPlan = createAction(
  "CREATE_DISCOUNT_PLAN",
  ({ payload, body }: SagaActionParams<Type.DiscountPlanDto>) => ({
    payload,
    url: "/api/admin/discountplan",
    body,
  })
);
export const updateDiscountPlan = createAction(
  "UPDATE_DISCOUNT_PLAN",
  ({ payload, id, body }: SagaActionParams<Type.DiscountPlanDto>) => ({
    payload,
    url: "/api/admin/discountplan/" + id,
    body,
  })
);
export const deleteDiscountPlan = createAction(
  "DELETE_DISCOUNT_PLAN",
  ({ payload, id }: SagaActionParams<Type.DiscountPlanDto>) => ({
    payload,
    url: "/api/admin/discountplan/" + id,
  })
);

const discountPlanSaga = [
  takeLatest<any>(
    getDiscountPlans.toString(),
    (payload: SagaGenericParams<Type.DiscountPlanDto[]>) =>
      getSaga<Type.DiscountPlanDto[]>(payload)
  ),
  takeLatest<any>(
    getDiscountPlanDetails.toString(),
    (payload: SagaGenericParams<Type.DiscountPlanDetailDto>) =>
      getSaga<Type.DiscountPlanDetailDto>(payload)
  ),
  takeLatest<any>(
    createDiscountPlan.toString(),
    (payload: SagaGenericParams<Type.DiscountPlanDto>) =>
      postSaga<Type.DiscountPlanDto>(payload)
  ),
  takeLatest<any>(
    updateDiscountPlan.toString(),
    (payload: SagaGenericParams<Type.DiscountPlanDto>) =>
      putSaga<Type.DiscountPlanDto>(payload)
  ),
  takeLatest<any>(
    deleteDiscountPlan.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Type.DiscountPlanDto>(payload)
  ),
];

export default discountPlanSaga;
